import { Box, Modal, Stack, TextareaAutosize } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import {
  CustomButton,
  CustomDateField,
  FormModalTitle,
} from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 400, md: 550, lg: 550 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  padding: 3,
};

interface Props {
  open: boolean;
  onClose(): void;
}

function BossBlocageModal({ open, onClose }: Props) {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   surname: "",
  //   email: "",
  //   phone: "",
  //   localisation: "",
  // });
  const [date, setDate] = useState(dayjs(new Date()));

  // const onChangeField = (key: string, value: string) => {
  //   setFormData({
  //     ...formData,
  //     [key]: value,
  //   });
  // };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t("motif_blocage")}
            onClose={handleClose}
          />
          <Stack direction={"row"} justifyContent="space-between">
            <CustomDateField
              value={date}
              title={capitalizeFirstLetter(i18n.t("date_debut"))}
              onChange={(val) => setDate(val)}
              rootStyle={{marginRight: 2}}
            />
            <CustomDateField
              value={date}
              title={capitalizeFirstLetter(i18n.t("date_fin"))}
              onChange={(val) => setDate(val)}
              rootStyle={{marginLeft: 2}}
            />
          </Stack>
          <SigninTextInput
            title={""} onChange={function (value: string): void {
              throw new Error("Function not implemented.");
            } }   
            component={
              <TextareaAutosize 
              minRows={6}
              placeholder={capitalizeFirstLetter(i18n.t("motif_blocage_desc"))}
              style={{
                width: "100%",
                borderRadius: 8,
                borderColor: "#bcbbbe",
                padding: 15,
              }}
              />
            }           
              />
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("enregistrer"))}
            //   onClick={onSubmit}
            //   disabled={disabled}
            rootStyle={{
              width: "100%",
              height: 50,
              marginTop: 10,
              marginBottom: 2,
            }}
            titleStyle={{ color: theme.colors.white }}
          />
        </Box>
      </form>
    </Modal>
  );
}

export default BossBlocageModal;
